const ActivityView = () => {
  return <div></div>;
};

export default ActivityView;
